// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76934ebb","238":"a81a4aea","455":"3d6cad59","488":"a9ece8c1"}[chunkId] + ".chunk.js";
};